/**
 * GuidesLink — the fleet Guides navigation element (DR-2026-272).
 *
 * Links every tenant to the guides.ljusa-tider.se commons (DR-2026-270): the
 * marketing tutorial, sector modules, and the platform's shared publishing
 * home. Per the s527 delivery decision the entry ships in the baseline addon
 * so every current + future tenant carries it automatically; per-tenant
 * calibration (the "degree of customization") is config, never content:
 *
 *   config.settings.tenantBaseline = {
 *     guidesUrl:         commons origin (default guides.ljusa-tider.se)
 *     guidesSectorPath:  '' | '/medical' | ... (sector-module entry point,
 *                        AFTER the language root: content lives at /en/...)
 *     guidesLabel:       null => i18n default; string overrides ("Academy")
 *     guidesLanguageMap: true => append /{lang} with fallback to /en
 *     guidesLanguages:   language roots live on the commons (['en'] today)
 *     tenantKey:         appended as ?from=<key> for the commons-side
 *                        ReturnLink (return navigation, s529 wave)
 *     isCommons:         true on guides itself => render nothing
 *   }
 *
 * Plain anchor, not a router Link — the commons is a different origin; a
 * router Link would client-route and 404. SSR-safe: no window access.
 */
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';

const messages = defineMessages({
  guides: {
    id: 'tenantBaseline.guides',
    defaultMessage: 'Guides',
  },
});

const GuidesLink = () => {
  const intl = useIntl();
  const tb = config.settings.tenantBaseline || {};
  if (!tb.guidesUrl) return null;
  // The commons never links to itself (ReturnLink owns that slot there).
  if (tb.isCommons) return null;

  let langPath = '';
  if (tb.guidesLanguageMap) {
    const lang = toBackendLang(intl.locale);
    const roots = tb.guidesLanguages || ['en'];
    langPath = `/${roots.includes(lang) ? lang : 'en'}`;
  }
  // Language root FIRST — commons content lives under it (/en/medical),
  // so the sector path composes after (order corrected s529; was latent).
  const fromParam = tb.tenantKey
    ? `?from=${encodeURIComponent(tb.tenantKey)}`
    : '';
  const href = `${tb.guidesUrl}${langPath}${tb.guidesSectorPath || ''}${fromParam}`;
  const label = tb.guidesLabel || intl.formatMessage(messages.guides);

  return (
    <a className="tenant-baseline-guides-link" href={href} rel="noopener">
      {label}
    </a>
  );
};

export default GuidesLink;
